import React, { PureComponent } from 'react';
import { DirectionsRenderer } from 'react-google-maps';

import { COLORS } from 'shared/constants/theme';

export default class MapDirections extends PureComponent {
  render() {
    const { directions } = this.props;
    if (!directions) {
      return false;
    }

    return (
      <DirectionsRenderer
        directions={directions}
        options={{
          preserveViewport: false, // set true to disable map recenter
          polylineOptions: {
            strokeColor: COLORS.cerulean
          },
          suppressMarkers: true
        }}
      />
    );
  }
}
